module.exports = __webpack_public_path__ + "img/img8.5d5c5b42.png";